import ArrayObjectInput from "./ArrayObjectInput";

export default ArrayObjectInput;
